import { cn } from "@bcc/lib/utils";
import { Eye, EyeOff } from "lucide-react";
import * as React from "react";
import { Input } from "./input";

interface PasswordInputProps extends Omit<React.ComponentProps<"input">, "type"> {
  testId?: string;
  toggleTestId?: string;
}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(({ className, testId, toggleTestId, ...props }, ref) => {
  const [visible, setVisible] = React.useState(false);

  return (
    <div className={cn("relative", className)}>
      <Input ref={ref} data-testid={testId} type={visible ? "text" : "password"} className="pr-10" {...props} />
      <button
        type="button"
        data-testid={toggleTestId}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-muted-foreground hover:text-foreground"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});

PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
